import { useEffect } from "react";
import PublicReviewsList from "@/components/PublicReviewsList";

export default function EmbedReviews() {
  useEffect(() => {
    // Transparent host so it slots cleanly into a WordPress iframe.
    document.body.style.background = "transparent";
    return () => { document.body.style.background = ""; };
  }, []);
  return (
    <div style={{ background: "transparent" }}>
      <PublicReviewsList compact />
    </div>
  );
}
